import React from 'react';
import { getTargetDisplay } from '../utils/activationCodeUtils';

// Tên sách hoặc bộ sách của lô/mã; bộ sách kèm nhãn để phân biệt với sách lẻ
const TargetTitle = ({ item, fallback = 'N/A' }) => {
  const { isCollection, title } = getTargetDisplay(item);

  if (!isCollection) return <>{title || fallback}</>;

  return (
    <>
      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-800 mr-1">
        Bộ sách
      </span>
      {title}
    </>
  );
};

export default TargetTitle;
